<div class="lot-kpi">
  <div class="container">
    <div class="col-md-3 background-light-blue text-white height-box font-row">
      <h4 class="h-padding-box">
        <b>Requested</b>
      </h4>
      <p><b>Quantity: </b> {{ (kpiData | async)?.requestedQuantity }}</p>
      <p><b>Value: </b> {{ (kpiData | async)?.requestedValue | myCurrency }}</p>
      <p><b>Purchase price: </b> {{ (kpiData | async)?.requestedPurchasePrice | myCurrency }}</p>
      <p><b>Virtual Purchase price: </b> {{ (kpiData | async)?.virtualRequestedPurchasePrice | myCurrency }}</p>
    </div>

    <div class="col-md-3 background-blue text-white height-box font-row">
      <h4 class="h-padding-box">
        <b>Confirmed</b>
      </h4>
      <p><b>Quantity: </b> {{ (kpiData | async)?.acceptedQuantity }}</p>
      <p><b>Value: </b> {{ (kpiData | async)?.acceptedValue | myCurrency }}</p>
      <p><b>Purchase price: </b> {{ (kpiData | async)?.acceptedPurchasePrice | myCurrency }}</p>
      <p><b>Virtual Purchase price: </b> {{ (kpiData | async)?.virtualAcceptedPurchasePrice | myCurrency }}</p>
    </div>

    <div class="col-md-3 background-light-blue text-white height-box font-row">
      <h4 class="h-padding-box">
        <b>Ordered</b>
      </h4>
      <p><b>Quantity: </b> {{ (kpiData | async)?.orderedQuantity }}</p>
      <p><b>Value: </b> {{ (kpiData | async)?.orderedValue | myCurrency }}</p>
      <p><b>Purchase price: </b> {{ (kpiData | async)?.orderedPurchasePrice | myCurrency }}</p>
      <p><b>Virtual Purchase price: </b> {{ (kpiData | async)?.virtualOrderedPurchasePrice | myCurrency }}</p>
    </div>

    <div class="col-md-3 background-blue text-white height-box font-row">
      <h4 class="h-padding-box">
        <b>Margin</b>
      </h4>
      <p><b>Value: </b> {{ (kpiData | async)?.margin | myCurrency }}</p>
      <p><b>Percent: </b> {{ (kpiData | async)?.percentMargin | percentageFromDecimal }}</p>
      <p><b>Virtual Value: </b> {{ (kpiData | async)?.virtualMargin | myCurrency }}</p>
      <p><b>Virtual Percent: </b> {{ (kpiData | async)?.virtualPercentMargin | percentageFromDecimal }}</p>
    </div>
  </div>
</div>
